import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import CreditVehiclesAnimator from "./CreditVehiclesAnimator";
import { getCreditVehiclesShowImporter } from "../vehicles.selectors";
import { CREDIT_VEHICLES_SLICE_NAME } from "../vehicles.constants";
import {
  toggleShowImporter as toggleShowImporterCreator,
  setShowImporter as setShowImporterCreator
} from "../vehicles.actions";

class CreditVehiclesAnimatorContainer extends Component {
  componentWillUnmount() {
    const {
      props: { setShowImporter }
    } = this;
    setShowImporter(false);
  }

  render() {
    const { showImporter, toggleShowImporter } = this.props;
    return (
      <CreditVehiclesAnimator
        showSlide2={showImporter}
        toggleShowing={toggleShowImporter}
      />
    );
  }
}

CreditVehiclesAnimatorContainer.propTypes = {
  showImporter: PropTypes.bool.isRequired,
  toggleShowImporter: PropTypes.func.isRequired,
  setShowImporter: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  showImporter: getCreditVehiclesShowImporter(state)
});

const mapDispatchToProps = dispatch => ({
  toggleShowImporter: () =>
    dispatch(toggleShowImporterCreator(CREDIT_VEHICLES_SLICE_NAME)),
  setShowImporter: showImporter =>
    dispatch(setShowImporterCreator(CREDIT_VEHICLES_SLICE_NAME, showImporter))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreditVehiclesAnimatorContainer)
);
